import React from 'react'
import { Link } from 'react-router-dom'
import "./TrendingBrand.scss"
export default function TrendingBrand({data, title}) {
    console.log(data) 
    return ( 
        <div className="trending-brand-wrapper">
            <div className="container">
                <h4 className="section-title">{title}</h4>
                <div className="trending-brand-content">
                    {data?.map(brand => (
                        <Link to={`/brand/${brand.id}/${brand.name}`} key={brand.id} className="brand-holder">
                            <img src={brand.image} alt={brand.name} />  
                        </Link> 
                    ))} 
                </div>
            </div>
        </div>
    )
}
